import * as React from "react";
import { Paperclip } from "lucide-react";
import type { UserFile } from "../api/finster/userFiles";
import { useUserFileLookup } from "../hooks/useUserFileLookup";
import { AttachmentChip } from "./AttachmentChip";

interface SelectedUserFileChipsProps {
  selectedFileIds: readonly string[];
  onRemoveFileId: (fileId: string) => void;
  /** Optional host-provided display metadata, such as attachment provenance. */
  fileDescriptionsById?: Readonly<Record<string, string | undefined>>;
  disabled?: boolean;
}

export const SelectedUserFileChips: React.FC<SelectedUserFileChipsProps> = ({
  selectedFileIds,
  onRemoveFileId,
  fileDescriptionsById = {},
  disabled = false,
}) => {
  const fileLookup = useUserFileLookup(selectedFileIds);
  const resolvedFiles = selectedFileIds
    .map((fileId) => fileLookup.get(fileId))
    .filter((file): file is UserFile => file !== undefined);

  if (resolvedFiles.length === 0) {
    return null;
  }

  return (
    <div
      className="flex shrink-0 flex-nowrap items-start gap-2"
      aria-label="Selected files"
    >
      {resolvedFiles.map((file) => (
        <AttachmentChip
          key={file.id}
          icon={<Paperclip />}
          label={file.name}
          description={fileDescriptionsById[file.id]}
          onRemove={() => onRemoveFileId(file.id)}
          disabled={disabled}
        />
      ))}
    </div>
  );
};
